import SecurityQuestion from './SecurityQuestion';

export default SecurityQuestion;
